import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsNumberHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Number;
    }
}

//# sourceMappingURL=IsNumberHelper.js.map
